import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'

// const baseURL = "http://127.0.0.1:9090/";
const baseURL = "/";
// axios.defaults.headers['lang'] = Cookies.get('SET_LANG') ? Cookies.get('SET_LANG') : 'zh-CN'
axios.defaults.headers['lang'] = Cookies.get('SET_LANG') ? Cookies.get('SET_LANG') : 'en-US'
axios.defaults.timeout = 100000

const api = {
  get: function (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(baseURL + url, {
          params,
        })
        .then(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  post: function (url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.post(baseURL + url, data).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
}

/**
 * methods: post
 */

Vue.prototype.$axios = api
Vue.prototype.$queryUrl = baseURL